import content from './content'
import contentAttachments from './contentAttachments'
import contentCommentForm from './contentCommentForm'
import contentExport from './contentExport'
import contentFilter from './contentFilter'
import contentComments from './contentComments'
import contentForm from './contentForm'
import contentLayout from './contentLayout'
import contentModal from './contentModal'
import contentShareModal from './contentShareModal'
import contentCopyModal from './contentCopyModal'
import contents from './contents'

export default {
  content,
  contentAttachments,
  contentCommentForm,
  contentExport,
  contentFilter,
  contentComments,
  contentForm,
  contentLayout,
  contentModal,
  contentShareModal,
  contentCopyModal,
  contents
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/index.js